import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 2.5rem;
  padding-bottom: 2rem;

  .title {
    font-weight: bold;
    color: var(--medGrey);
  }

  .author {
    color: gray;
  }

  .show-more-btn {
    border: none;
    border-radius: 60px;
  }

  .info {
    color: grey;
  }

  .bookmark {
    background: none;
    border: none;
    font-size: 3rem;
    color: var(--brandSecondary);
  }

  .edit-btn {
    padding: 5px 10px;
    background: none;
    border-radius: 16px;
    border-color: var(--brandSecondary);
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--brandSecondary);

    :hover {
      background-color: var(--brandSecondary);
      color: var(--white);
    }
  }
`;
